module.exports = __webpack_public_path__ + "assets/c47eac32811c482b503bda9ec22dc699.svg";